import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Params, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { AddressesService } from "../services/addresses.service"
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  client;
  clientid;
  user;
  referer;
  isLoggedIn$: Observable<boolean>
  shipperValid = false;
  newClient;
  shipperid = 1; // set when new shipper id returned from DB (index for now)

  constructor(private router: Router,
              private route: ActivatedRoute,
              private addressesService: AddressesService,
              private location: Location,
              private authService: AuthService ) {  }

  ngOnInit() {
        // Create newClient object to use in html
    this.newClient = {
      cname: "", address: "", city: "", state: "", zip: "", contact: "",  phone: "", userid: "", lname: "", fname: ""
    }
    this.route.params
    .subscribe(
      (params: Params) => {
        this.clientid = + params['clientid'];
      }
    );
    this.onStartup();

  }

  onStartup() {
    this.isLoggedIn$ = this.authService.isLoggedIn$
    this.authService.user$.subscribe((user:any) => {
      this.user = user;
      if(!user.message) {
        if( user.clientid == 0) {
          this.authService.client$.subscribe((client) => {
            this.client = client;
          });
        }else { 
          this.authService.client$.subscribe((client) => {
            this.client = client;
            if(client.cname != 'No Client Selected' && user.clientid != 0){
              
              }
            })
        }
      }        
    })
  }

    onCancelClose(bool) {
      this.location.back();
  }

    onValidateForm() {    
    if(this.newClient.cname != "" &&
        this.newClient.address !=""&&
        this.newClient.city !="" &&
        this.newClient.state !="" &&
        this.newClient.zip !="" &&
        this.newClient.fname !="" &&
        this.newClient.lname !="" &&
        this.newClient.phone !="" 
    ) {      
      this.shipperValid = true;
    }
  }

  onSaveNewClient(){
    this.newClient.userid = this.user.userid;
    this.addressesService.onAddClient(this.newClient)
    .then(newAddress => {
      let inserted = newAddress;
      
      this.location.back();
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts